import React from 'react';

interface StepNavButtonsProps {
  onCancel: () => void;
  onContinue: () => void;
  continueLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
  /** Show a loading/processing state on the continue button */
  loading?: boolean;
  /** Make cancel flex:1 and continue flex:2 (default). Set false for equal widths. */
  weighted?: boolean;
}

/**
 * Standard navigation button row at the bottom of each signup step.
 * Provides consistent styling for Cancel / Continue across all steps.
 */
const StepNavButtons: React.FC<StepNavButtonsProps> = ({
  onCancel,
  onContinue,
  continueLabel = 'Continue →',
  cancelLabel = 'Cancel',
  disabled = false,
  loading = false,
  weighted = true,
}) => {
  const isDisabled = disabled || loading;

  return (
    <div style={{
      display: 'flex', gap: 12,
      paddingTop: 20,
      borderTop: '1px solid #E2E8F0',
    }}>
      <button
        onClick={onCancel}
        disabled={loading}
        data-testid="step-nav-cancel-btn"
        style={{
          flex: weighted ? 1 : undefined,
          padding: '14px 24px',
          background: '#fff', border: '1px solid #E2E8F0',
          borderRadius: 10, color: loading ? '#94A3B8' : '#64748B',
          fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease',
        }}
      >
        {cancelLabel}
      </button>
      <button
        onClick={onContinue}
        disabled={isDisabled}
        data-testid="step-nav-continue-btn"
        style={{
          flex: weighted ? 2 : undefined,
          padding: '14px 24px',
          background: isDisabled
            ? '#E2E8F0'
            : 'linear-gradient(135deg, #0F2647 0%, #1B3A6B 100%)',
          border: 'none', borderRadius: 10,
          color: isDisabled ? '#94A3B8' : '#fff',
          fontSize: 15, fontWeight: 700, cursor: isDisabled ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        }}
      >
        {loading ? 'Processing…' : continueLabel}
      </button>
    </div>
  );
};

export default StepNavButtons;
